export default {
  title: '商品管理',
  productList: '商品一覧',
  addProduct: '商品追加',
  editProduct: '商品編集',
};
